module.exports = __webpack_public_path__ + "static/media/elephant.2db56f09.svg";